module.exports = __webpack_public_path__ + "static/media/1029618.b6776a5c.jpg";